// Wizard step visits: record which way the user travelled so the next step body slides in from that side.
// The header marks its position with data-wizard-flow / data-wizard-step; turbo:before-render compares the
// outgoing and incoming pages and leaves the result on <html data-wizard-dir>, which the view-transition CSS
// (web) and wizard_step_controller (native / no View Transitions) both read.

export function readWizardPosition(root) {
  const el = root?.querySelector?.("[data-wizard-flow]")
  if (!el) return null
  const step = Number(el.dataset.wizardStep)
  return Number.isFinite(step) ? { flow: el.dataset.wizardFlow, step } : null
}

export function directionBetween(from, to) {
  if (!from || !to || from.flow !== to.flow || from.step === to.step) return null
  return to.step > from.step ? "forward" : "back"
}

export function wizardDirection(doc = globalThis.document) {
  return doc?.documentElement?.dataset?.wizardDir || null
}

export function installWizardTransitions(doc = globalThis.document) {
  doc.addEventListener("turbo:before-render", (event) => {
    const dir = directionBetween(readWizardPosition(doc.body), readWizardPosition(event.detail?.newBody))
    if (dir) {
      doc.documentElement.dataset.wizardDir = dir
    } else {
      delete doc.documentElement.dataset.wizardDir
    }
  })
}
